import { CommonModule } from '@angular/common';
import {
	ChangeDetectorRef,
	Directive,
	ElementRef,
	HostBinding,
	HostListener,
	Inject,
	Input,
	NgModule,
} from '@angular/core';

import { CLIENT_ENVIRONMENT } from '~app-client/core/tokens';
import { ClientEnvironment } from '~app-client/core/types';

import { http2Https } from '../pipes/http-2-https';

@Directive({
	standalone: false,
	selector: 'img',
})
export class ReachImgDirective {
	@HostBinding('class.use-width')
	public get useWidth(): boolean {
		return (
			this.elementRef.nativeElement.naturalWidth < this.elementRef.nativeElement.naturalHeight
		);
	}

	@HostBinding('class.use-height')
	public get useHeight(): boolean {
		return (
			this.elementRef.nativeElement.naturalHeight < this.elementRef.nativeElement.naturalWidth
		);
	}

	constructor(
		@Inject(CLIENT_ENVIRONMENT) private readonly environment: ClientEnvironment,
		private elementRef: ElementRef<HTMLImageElement>,
		private cdRef: ChangeDetectorRef
	) {}

	@Input()
	public set src(src: string) {
		if (this.environment.production) {
			this._src = http2Https(src || '', this.environment);
		} else {
			this._src = src;
		}
	}

	@HostBinding('attr.src')
	public _src?: string;

	@HostListener('load')
	protected onLoad(): void {
		this.cdRef.detectChanges();
	}
}

@NgModule({
	declarations: [ReachImgDirective],
	imports: [CommonModule],
	exports: [ReachImgDirective],
})
export class ReachImgModule {}
